import { render, staticRenderFns } from "./inventoryLog3.vue?vue&type=template&id=124dc605&scoped=true&"
import script from "./inventoryLog3.vue?vue&type=script&lang=js&"
export * from "./inventoryLog3.vue?vue&type=script&lang=js&"
import style0 from "./inventoryLog3.vue?vue&type=style&index=0&id=124dc605&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124dc605",
  null
  
)

export default component.exports